import { atom } from 'recoil';

// Deprecated
export const goodOptionListState = atom({
  key: 'goodOptionListState',
  default: [],
});

export const goodSelectedRegularDelivery = atom({
  key: 'goodSelectedRegularDelivery',
  default: {
    period: {
      code: '',
      name: '',
    },
    total: null,
    time: null,
    startDateTime: null,
  },
});

export const goodWishState = atom({
  key: 'goodWishState',
  default: false,
});

export const receiptDateForMultiOptionState = atom({
  key: 'receiptDateForMultiOptionState',
  default: null,
});
export const couponListForDownloadState = atom({
  key: 'couponListForDownloadState',
  default: [],
});

export const goodTabInfoState = atom({
  key: 'goodTabInfoState',
  default: 0,
});

export const newGoodListState = atom({
  key: 'newGoodListState',
  default: [],
});
